import { GraniteButton } from 'components/V2/Button/GraniteButton';
import { OpenOutline, Shuffle } from 'react-ionicons';
import clsx from 'clsx';
import { observer } from 'mobx-react-lite';
import { useCartContext } from 'screens/AccessExpressV3/CartProvider';
import {
  AlternativeOfferType,
  handleAccessCategorySelection,
} from 'screens/AccessExpressV3/utils';
import { ProductCategory } from 'screens/AccessExpressV3/accessExpress.types';
import { useNavigate } from 'react-router-dom';
import { useAuthUser } from 'hooks/useAuthUser';

interface CheckServiceButtonProps {
  type: AlternativeOfferType;
  className?: string;
  variant?: 'secondary' | 'tertiary';
  isAllProducts?: boolean;
}

const CheckServiceButton = observer(
  ({
    type,
    className,
    variant = 'secondary',
    isAllProducts,
  }: CheckServiceButtonProps) => {
    const navigate = useNavigate();
    const userInfo = useAuthUser();

    if (type === 'cradlepoint') return null;

    // leave this here for now, we will need to add a new button for cradlepoint
    // const label = type === 'cradlepoint' ? 'View' : 'Check availability';
    const label = isAllProducts ? 'Switch to ' + type : 'Check availability';

    const cart = useCartContext();

    const handleButtonClick = () => {
      if (type) {
        if (isAllProducts) {
          cart.selectAccessProductCategory(type as ProductCategory);
          return;
        }
        navigate(`/access-express/v3/access/product/${type}`, {
          replace: true,
        });
        cart.setLoadingDraftQuote(true);

        setTimeout(() => {
          handleAccessCategorySelection({
            type: type as ProductCategory,
            cart,
            userInfo,
            setStartPolling: cart.setStartPolling,
            setLoadingDraftQuote: cart.setLoadingDraftQuote,
          });
        }, 0);
      }
    };

    return (
      <GraniteButton
        variant={variant}
        size="medium"
        className={clsx('!cursor-pointer whitespace-nowrap', className)}
        onClick={handleButtonClick}
      >
        {label}
        {isAllProducts ? (
          <Shuffle width="20px" height="20px" color="inherit" />
        ) : (
          <OpenOutline width="18px" height="18px" color="inherit" />
        )}
      </GraniteButton>
    );
  },
);

export default CheckServiceButton;
